var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movement-history-view card border-0"},[_c('div',{staticClass:"card-body"},[_c('movement-history-list',{attrs:{"entries":_vm.entries,"loading":_vm.loading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }